import axios from "@/request";
import qs from "qs";

export default {
  async list(params: any) {
    return axios.post("investigate/list", qs.stringify(params));
  },
  async items(params: any) {
    return axios.post("investigate/items", qs.stringify(params));
  },
  /* 提交审核 */
  async submit(params: any) {
    return axios.post("investigate/submit", qs.stringify(params));
  },
  async save(params: any) {
    return axios.post("investigate/save", qs.stringify(params));
  },
  async info(params: any) {
    return axios.get("investigate/info", {params});
  },
}
